<template>
  <div class="profile-section mx-4">
    <v-row>
      <v-col lg="6" md="12" cols="12">
        <v-card>
          <v-card-title class="xlg--text fontweight400 pt-6"
            >Change password</v-card-title
          >
          <v-card-text class="pb-0 mb-0">
            <v-row class="ma-2">
              <v-col class="pa-0 mb-6" cols="12">
                <v-text-field
                  v-model="$v.change_password.old_password.$model"
                  :type="showOldPassword ? 'text' : 'password'"
                  :error-messages="oldPasswordErrors"
                  :append-icon="showOldPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  @input="$v.change_password.old_password.$touch()"
                  @click:append="showOldPassword = !showOldPassword"
                  autofocus
                  label="Old password"
                ></v-text-field>
              </v-col>
              <v-col class="pa-0 mb-6" cols="12">
                <v-text-field
                  v-model="$v.change_password.new_password.$model"
                  :type="showNewPassword ? 'text' : 'password'"
                  :error-messages="newPasswordErrors"
                  :append-icon="showNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  @input="$v.change_password.new_password.$touch()"
                  @click:append="showNewPassword = !showNewPassword"
                  autofocus
                  label="New password"
                ></v-text-field>
              </v-col>
              <v-col class="pa-0 mb-6" cols="12">
                <v-text-field
                  v-model="$v.change_password.new_password_repeated.$model"
                  :type="showPasswordOneMoreTime ? 'text' : 'password'"
                  :error-messages="OneMoreTimePasswordErrors"
                  :append-icon="
                    showPasswordOneMoreTime ? 'mdi-eye' : 'mdi-eye-off'
                  "
                  @input="$v.change_password.new_password_repeated.$touch()"
                  @blur="$v.change_password.new_password_repeated.$touch()"
                  @click:append="
                    showPasswordOneMoreTime = !showPasswordOneMoreTime
                  "
                  label="New password one more time"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="justify-end pr-3">
            <v-btn
              text
              color="error"
              :disabled="isChangePasswordDisabled"
              @click="changeUserPassword"
            >
              CHANGE PASSWORD
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col lg="6" md="12" cols="12">
        <v-row class="ma-0">
          <v-col class="pa-0 mb-6" cols="12">
            <v-card>
              <v-card-title class="xlg--text fontweight400 pt-6"
                >API token</v-card-title
              >
              <v-card-text>
                <p class="fontlight--text xs--text">
                  {{ api_token }}
                </p>
              </v-card-text>
              <v-card-actions class="justify-end">
                <v-btn text class="fontweight400" @click="regenerateApiToken">
                  Generate new API token
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col
              class="pa-0 mb-6"
              cols="12"
              v-if="residential_credentials && residential_credentials.proxy_username"
          >
            <v-card>
              <v-card-title class="xlg--text fontweight400 pt-6">
                Reset residential password
              </v-card-title>
              <v-card-text>
                <p class="fontlight--text xs--text">
                  <b>Username</b>: {{ residential_credentials.proxy_username }}
                </p>
                <p class="fontlight--text xs--text">
                  <b>Password</b>: {{ residential_credentials.proxy_secret }}
                </p>
              </v-card-text>
              <v-card-actions class="justify-end">
                <v-btn
                    text
                    class="fontweight400"
                    @click="() => show_reset_residential_dialog = true"
                >
                  Reset password
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col
              class="pa-0 mb-6"
              cols="12"
              v-if="datacenter_credentials && datacenter_credentials.proxy_username"
          >
            <v-card>
              <v-card-title class="xlg--text fontweight400 pt-6">
                Reset datacenter password
              </v-card-title>
              <v-card-text>
                <p class="fontlight--text xs--text">
                  <b>Username</b>: {{ datacenter_credentials.proxy_username }}
                </p>
                <p class="fontlight--text xs--text">
                  <b>Password</b>: {{ datacenter_credentials.proxy_secret }}
                </p>
              </v-card-text>
              <v-card-actions class="justify-end">
                <v-btn
                    text
                    class="fontweight400"
                    @click="() => show_reset_datacenter_dialog = true"
                >
                  Reset password
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col
            class="pa-0 mb-6"
            cols="12"
            v-if="current_subscription && current_subscription.update_url"
          >
            <v-card>
              <v-card-title class="xlg--text fontweight400 pt-6">
                API payment details
              </v-card-title>
              <v-card-text>
                <p class="fontlight--text xs--text">
                  Change and update payment details
                </p>
              </v-card-text>
              <v-card-actions class="justify-end">
                <v-btn
                  text
                  class="fontweight400"
                  @click="onUpdatePaymentDetailsClicked"
                >
                  Update payment
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col
              class="pa-0 mb-6"
              cols="12"
              v-if="current_residential_subscription && current_residential_subscription.update_url"
          >
            <v-card>
              <v-card-title class="xlg--text fontweight400 pt-6">
                Residential proxy payment details
              </v-card-title>
              <v-card-text>
                <p class="fontlight--text xs--text">
                  Change and update payment details
                </p>
              </v-card-text>
              <v-card-actions class="justify-end">
                <v-btn
                    text
                    class="fontweight400"
                    @click="onUpdateResidentialPaymentDetailsClicked "
                >
                  Update payment
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col
              class="pa-0 mb-6"
              cols="12"
              v-if="current_datacenter_subscription && current_datacenter_subscription.update_url"
          >
            <v-card>
              <v-card-title class="xlg--text fontweight400 pt-6">
                Datacenter proxy payment details
              </v-card-title>
              <v-card-text>
                <p class="fontlight--text xs--text">
                  Change and update payment details
                </p>
              </v-card-text>
              <v-card-actions class="justify-end">
                <v-btn
                    text
                    class="fontweight400"
                    @click="onUpdateDatacenterPaymentDetailsClicked "
                >
                  Update payment
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col class="pa-0" cols="12">
            <v-card>
              <v-card-title class="xlg--text fontweight400 pt-6">
                Remove account
              </v-card-title>
              <v-card-text>
                <p class="fontlight--text xs--text">
                  All user-related data will be removed
                </p>
              </v-card-text>
              <v-card-actions class="justify-end">
                <v-btn
                  text
                  color="error"
                  class="fontweight400"
                  @click="initiateRemoval"
                >
                  Remove account
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-dialog v-model="remove_dialog_active" max-width="550">
      <v-card>
        <v-card-title> Are you sure want to delete your account? </v-card-title>
        <v-card-text>
          You will no longer be able to use ScrapingAnt without new
          registration.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="remove_dialog_active = false"> Cancel </v-btn>
          <v-btn color="primary" text @click="onConfirmRemove"> Remove </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="cancel_subscription_dialog_active" max-width="800">
      <v-card>
        <v-card-title> Account removal </v-card-title>
        <v-card-text>
          You have the active paid subscription. Please, navigate to
          <a class="text-decoration router-link" href="/subscriptions"
            >Subscriptions page</a
          >
          to cancel your subscription first.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            @click="cancel_subscription_dialog_active = false"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="password_changed_dialog_active" max-width="350">
      <v-card>
        <v-card-text class="pt-5">
          Your password has been successfully changed!
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="onPasswordChangedDialogClose">
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="password_failed_dialog_active" max-width="450">
      <v-card>
        <v-card-title> Failed to change the password! </v-card-title>
        <v-card-text>
          Please try again or contact us via
          <a
            class="text-decoration router-link"
            href="mailto:support@scrapingant.com"
            >support@scrapingant.com</a
          >
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            @click="onPasswordChangeFailedDialogClose"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="show_reset_residential_dialog" max-width="450">
      <v-card>
        <v-card-title>Are you sure?</v-card-title>
        <v-card-text>
          Your active residential credentials will be reset. All active sessions
          will be terminated.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              text
              color="primary"
              @click="onResetResidentialClicked"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="show_reset_datacenter_dialog" max-width="450">
      <v-card>
        <v-card-title>Are you sure?</v-card-title>
        <v-card-text>
          Your active datacenter credentials will be reset. All active sessions
          will be terminated. Changes will take effect within 15 minutes.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              text
              color="primary"
              @click="onResetDatacenterClicked"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="loading-overlay" v-if="loading">
      <v-progress-circular
        :size="50"
        :width="2"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import { minLength, required, sameAs } from "vuelidate/lib/validators";

export default {
  name: "Profile",
  data() {
    return {
      dialog: false,
      api_token: "",
      residential_credentials: {},
      datacenter_credentials: {},
      showOldPassword: false,
      showNewPassword: false,
      showPasswordOneMoreTime: false,
      change_password: {
        old_password: "",
        new_password: "",
        new_password_repeated: "",
      },
      current_subscription: null,
      current_residential_subscription: null,
      current_datacenter_subscription: null,
      remove_dialog_active: false,
      password_changed_dialog_active: false,
      password_failed_dialog_active: false,
      cancel_subscription_dialog_active: false,
      show_reset_residential_dialog: false,
      show_reset_datacenter_dialog: false,
      loading: false,
    };
  },
  validations: {
    change_password: {
      old_password: {
        required,
      },
      new_password: {
        required,
        minLength: minLength(6),
      },
      new_password_repeated: {
        required,
        sameAsPassword: sameAs("new_password"),
      },
    },
  },
  methods: {
    regenerateApiToken() {
      this.loading = true;
      this.$store.dispatch("profile/generateAndGetNewApiToken").then(
        (res) => {
          this.api_token = res.data.token;
          this.loading = false;
        },
        (err) => {
          console.log(err);
          this.loading = false;
        }
      );
    },
    initiateRemoval() {
      if (this.current_subscription.plan.price > 0) {
        this.cancel_subscription_dialog_active = true;
      } else {
        this.remove_dialog_active = true;
      }
    },
    onConfirmRemove() {
      this.remove_dialog_active = false;
      this.loading = true;
      this.$store.dispatch("profile/removeAccount").then(
        () => (this.loading = false),
        (err) => {
          console.log(err);
          this.loading = false;
        }
      );
    },
    getCurrentSubscription() {
      this.$store.dispatch("profile/getCurrentSubscription").then((res) => {
        this.current_subscription = res.data.subscriptions[0];
      }, console.log);
    },
    getCurrentResidentialSubscription() {
      this.$store.dispatch("profile/getCurrentResidentialSubscription").then(
        (res) => {
          this.current_residential_subscription = res;
        },
        console.log
      );
    },
    getCurrentDatacenterSubscription() {
      this.$store.dispatch("profile/getCurrentDatacenterSubscription").then(
          (res) => {
            this.current_datacenter_subscription = res;
          },
          console.log
      );
    },
    changeUserPassword() {
      this.loading = true;
      this.$store.dispatch("profile/changePassword", this.change_password).then(
        () => {
          this.loading = false;
          this.password_changed_dialog_active = true;
        },
        (err) => {
          console.log(err);
          this.loading = false;
          this.password_failed_dialog_active = true;
        }
      );
    },
    onPasswordChangedDialogClose() {
      this.password_changed_dialog_active = false;
      this.$router.go();
    },
    onPasswordChangeFailedDialogClose() {
      this.password_failed_dialog_active = false;
      this.$router.go();
    },
    onUpdatePaymentDetailsClicked() {
      // eslint-disable-next-line no-undef
      Paddle.Checkout.open({
        override: this.current_subscription.update_url,
        successCallback: () => {
          // TODO: add logging for tracking
        },
        closeCallback: () => {
          // TODO: add logging for tracking
        },
      });
    },
    onUpdateResidentialPaymentDetailsClicked() {
      // eslint-disable-next-line no-undef
      Paddle.Checkout.open({
        override: this.current_residential_subscription.update_url,
        successCallback: () => {
          // TODO: add logging for tracking
        },
        closeCallback: () => {
          // TODO: add logging for tracking
        },
      });
    },
    onUpdateDatacenterPaymentDetailsClicked() {
      // eslint-disable-next-line no-undef
      Paddle.Checkout.open({
        override: this.current_datacenter_subscription.update_url,
        successCallback: () => {
          // TODO: add logging for tracking
        },
        closeCallback: () => {
          // TODO: add logging for tracking
        },
      });
    },
    getResidentialCredentials() {
      return this.$store.dispatch("profile/getResidentialCredentials").then(
        (res) => {
          this.residential_credentials = res;
          this.loading = false;
        },
        (err) => {
          console.log(err);
          this.loading = false;
        }
      );
    },
    getDatacenterCredentials() {
      return this.$store.dispatch("profile/getDatacenterCredentials").then(
          (res) => {
            this.datacenter_credentials = res;
            this.loading = false;
          },
          (err) => {
            console.log(err);
            this.loading = false;
          }
      );
    },
    async onResetResidentialClicked() {
      this.show_reset_residential_dialog = false;
      try {
        this.loading = true;
        await this.$store.dispatch("profile/resetResidentialCredentials");
        await new Promise(r => setTimeout(r, 2000));
        await this.getResidentialCredentials();
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },
    async onResetDatacenterClicked() {
      this.show_reset_datacenter_dialog = false;
      try {
        this.loading = true;
        await this.$store.dispatch("profile/resetDatacenterCredentials");
        await new Promise(r => setTimeout(r, 2000));
        await this.getDatacenterCredentials();
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.loading = true;
    this.getCurrentSubscription();
    this.getCurrentResidentialSubscription();
    this.getCurrentDatacenterSubscription();
    this.getResidentialCredentials();
    this.getDatacenterCredentials();
    this.$store.dispatch("profile/getApiToken").then(
      (res) => {
        this.api_token = res.data.token;
        this.loading = false;
      },
      (err) => {
        console.log(err);
        this.loading = false;
      }
    );
  },
  computed: {
    oldPasswordErrors() {
      const errors = [];
      if (!this.$v.change_password.old_password.$dirty) return errors;
      !this.$v.change_password.old_password.required &&
        errors.push("Please, enter your password");
      return errors;
    },
    OneMoreTimePasswordErrors() {
      const errors = [];
      if (!this.$v.change_password.new_password_repeated.$dirty) return errors;
      !this.$v.change_password.new_password_repeated.required &&
        errors.push("Passwords not match :(");
      !this.$v.change_password.new_password_repeated.sameAsPassword &&
        errors.push("Passwords not match :(");
      return errors;
    },
    newPasswordErrors() {
      const errors = [];
      if (!this.$v.change_password.new_password.$dirty) return errors;
      !this.$v.change_password.new_password.required &&
        errors.push("Please, enter password with length of 6 symbols or more");
      !this.$v.change_password.new_password.minLength &&
        errors.push("Please, enter password with length of 6 symbols or more");
      return errors;
    },
    isChangePasswordDisabled() {
      return (
        this.$v.change_password.old_password.$error ||
        this.$v.change_password.new_password.$error ||
        this.$v.change_password.new_password_repeated.$error ||
        !this.$v.change_password.old_password.$dirty ||
        !this.$v.change_password.new_password.$dirty ||
        !this.$v.change_password.new_password_repeated.$dirty
      );
    },
  },
};
</script>

<style scoped>
.md-card {
  margin: 15px;
}
</style>
